import type { HostedModuleDetails as GraftHostedModule } from '@graft/nuget-gc.webportals.gateways'

export async function readHostedModuleVersionInstanceId(entity: GraftHostedModule): Promise<string> {
  if (typeof entity.get_moduleVersionInstanceId !== 'function') {
    return ''
  }

  try {
    const moduleVersionInstanceId = await entity.get_moduleVersionInstanceId()
    return moduleVersionInstanceId?.trim() ?? ''
  } catch {
    return ''
  }
}
